/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import clsx from 'clsx';
import { Pagination as AntdPagination } from 'antd';

import s from './styles.module.less';

const itemRender = (page, type, originalElement) => {
  if (type === 'prev') return <a>&lt;&lt; Previous</a>;
  if (type === 'next') return <a>Next &gt;&gt;</a>;
  if (type === 'jump-next') return <a>...</a>;
  if (type === 'jump-prev') return <a>...</a>;
  return originalElement;
};

const Pagination = ({ className, ...props }) => (
  <AntdPagination showSizeChanger={false} {...props} className={clsx(s.custom, className)} itemRender={itemRender} />
);

export default Pagination;
